var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscription-curiculum-view flex-between-wrapper" },
    [
      _c("img", {
        staticClass: "feature-image",
        attrs: { src: "/assets/app/class/curiculum-frame-bg.png" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "premium-curiculum-view" }, [
        _c("h3", { staticClass: "view-title" }, [
          _vm._v("Know where each student stands, every step of the way."),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "view-description" }, [
          _vm._v(
            "Track individual student and class performance in real-time. View progress reports by Lexile level, Curriculum standard, and Grade level. Easily export data to a CSV for even more insights!"
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-wrapper" },
          [
            _c("primary-button", { on: { click: _vm.handleClickPlan } }, [
              _vm._v("Choose your plan"),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }